import { CardElement } from "@stripe/react-stripe-js";

export const PaymentStripeForm = () => {
  return <CardElement />;
};
